import Storage from 'vue-ls'

const options = {
  namespace: 'mf-',
  name: 'ls',
  storage: 'session',
}

const { ls } = Storage.useStorage(options)

export const setData = (key, data) => {
  ls.set(key, JSON.stringify(data))
}

export const getData = (key, defaultData = '') => {
  const data = ls.get(key, defaultData)
  return data ? JSON.parse(data) : defaultData
}

export const removeData = (key) => {
  ls.remove(key)
}
